import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CustomerServiceService } from "../customer-service.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  token: any;
  dashboardArray: any = [];
  loading: boolean = false;

  constructor(
    private router: Router,
    private services: CustomerServiceService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.dashboardGet();
  }
  GoToDashboard() {
    this.router.navigate(["/dashboard"]);
  }
  GoToTrips() {
    this.router.navigate(["/trips"]);
  }
  GoToBookATrips() {
    this.router.navigateByUrl("/");
  }
  dashboardGet() {
    this.loading = true;
    this.services.dashboard(this.token).subscribe(
      (response: any) => {
        this.loading = false;
        this.dashboardArray = response.body.data;
      },
      (error) => {
        this.loading = false;
        this.dashboardArray = [];
        if (error.status == 404) {
          return;
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }
  GoTOHelp() {
    this.router.navigateByUrl("/?target=support");
  }
}
